import { render, staticRenderFns } from "./WarmUp3-3.vue?vue&type=template&id=6aef5112&"
import script from "./WarmUp3-3.vue?vue&type=script&lang=js&"
export * from "./WarmUp3-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports